module.exports = __webpack_public_path__ + "media/images/flags/16/Solomon-Islands-29c5dc5ca3845e0b3edd4ec0848acb30.png";